import { faArrowAltCircleUp } from "@fortawesome/free-solid-svg-icons/faArrowAltCircleUp";
import { faCamera } from "@fortawesome/free-solid-svg-icons/faCamera";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons/faPlusCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InputNumerico } from "app/components/inputs/InputNumerico";
import { TooltipMU } from "app/components/tooltip/TooltipMU";
import { IProduto } from "app/types/produto/IProduto";
import clsx from "clsx";
import globalMU from "globalMU";
import React, { useContext, useState } from "react";
import { PaginaPesquisaProdutoContext } from "../../pagina-pesquisa-produto/PaginaPesquisaProduto";
import { ProdutosSelecionadosContext } from "../../PaginaPesquisaProdutoContainer";
const estilosTabelas = require("../../../../estilos/tabelas.module.scss").default;
const estilosBotoes = require("../../../../estilos/botoes.module.scss").default;
const estilosBarraFerramentasGrid = require("./barra-ferramentas-grid.module.scss").default;
const estiloItemPesquisaProduto = require("../TBody/ItemPesquisaProduto.module.scss").default;

// 491123 — precisa bater com a duração da animação @keyframes removendoProdutoSelecionado em
// TabelaProdutosSelecionados.module.scss (ver barra-ferramentas-grid.module.scss).
const DURACAO_ANIMACAO_REMOCAO_MS = 300;

export const TabelaProdutosSelecionados = () => {
  const [produtosRepetidos, setProdutosRepetidos] = useState<{ [codigo: string]: string }>({});
  // 491123 — animação de remoção: a linha só some de fato (onRemoverProduto, que tira do redux e
  // desmonta) depois que a animação CSS (linhaRemovendo, ver .module.scss) termina de rodar.
  const [produtoRemovendo, setProdutoRemovendo] = useState<string | null>(null);
  const {
    produtosSelecionados,
    onRemoverProduto,
    onAlterarQuantidade,
    onAlterarAcaoProdutoRepetido,
    onMostrarInformacoesProduto,
    processandoProduto,
    produtoJaExisteNoOrcamento,
  } = useContext(ProdutosSelecionadosContext);
  const contexto = useContext(PaginaPesquisaProdutoContext);

  if ((produtosSelecionados ?? []).length === 0) {
    return <></>;
  }

  // Código e Referência seguem a mesma visibilidade configurada no GridItensPesquisaProdutos_TabelaProdutos; as demais colunas são fixas.
  const exibirColunaCodigo = contexto.colunas.find((c) => c.Nome == "Codigo")?.Selecionada == true;
  const exibirColunaReferencia = contexto.colunas.find((c) => c.Nome == "Referencia")?.Selecionada == true;

  // 491123 — chave de linha da cesta: identifica a linha renderizada (pode ser uma duplicata de
  // "Inserir Novo"), nunca o Codigo real do produto — duas duplicatas compartilham o mesmo Codigo
  const obterIdentificadorLinha = (produto: IProduto) => produto.IdentificadorLinhaCesta ?? produto.Codigo

  const onProdutoRepetido = (produto: IProduto) => {
    const identificadorLinha = obterIdentificadorLinha(produto)
    const novoProdutosRepetidos = { ...produtosRepetidos };

    const novoEstado = novoProdutosRepetidos[identificadorLinha] == undefined
      ? "desmembrar"
      : novoProdutosRepetidos[identificadorLinha] == "desmembrar"
        ? "incrementar"
        : "desmembrar";

    novoProdutosRepetidos[identificadorLinha] = novoEstado;
    setProdutosRepetidos(novoProdutosRepetidos);
    onAlterarAcaoProdutoRepetido(produto, novoEstado == "incrementar" ? 1 : 0);
  };

  // 491123 — dispara a animação de saída (linhaRemovendo) e só remove de fato do redux depois
  // que ela termina (DURACAO_ANIMACAO_REMOCAO_MS deve bater com a duração no .module.scss).
  const onRemoverComAnimacao = (produto: IProduto) => {
    setProdutoRemovendo(obterIdentificadorLinha(produto));
    setTimeout(() => onRemoverProduto(produto), DURACAO_ANIMACAO_REMOCAO_MS);
  };

  // 491123 — mesmo passo usado no stepper de ItemPesquisaProduto.tsx: a própria Venda Mínima do
  // produto (ou 1, quando não há) — onAlterarQuantidade (ProdutosSelecionadosContext) já ajusta
  // para o múltiplo mais próximo internamente, então não precisa repetir esse cálculo aqui.
  const obterPassoQuantidade = (produto: IProduto) => {
    //const quantidadeMinimaVenda = Number(globalMU.corrigirPontosEVirgulasValorDecimal(produto.QuantidadeMinimaVenda ?? "0"));
    const quantidadeMinimaVenda = produto.MenorFracaoVenda ?? 0;
    return quantidadeMinimaVenda > 0 ? quantidadeMinimaVenda : 1;
  };

  return (
    <>
      <div className={clsx(estilosTabelas.containerRolavel, estilosBarraFerramentasGrid.containerTabelaProdutosSelecionados)}>
        <table
          className={clsx(estilosBarraFerramentasGrid.tabelaCestaProdutos, "_w-full")}
          id="TabelaProdutosSelecionados_Tabela"
        >
          <thead
            id="TabelaProdutosSelecionados_Tabela_Cabecalho"
          >
            <tr>
              {/* 491123 — coluna da esquerda: só o stepper de quantidade (+ faixa colorida via
                  boxShadow). Os ícones de ação (informações, tinta, imagens, repetido, remover)
                  ficam concentrados na coluna "Ações" à direita, igual ao Figma (node-id 270-603).
                  O botão "Remover todos" fica no cabeçalho do Dialog, como
                  PaginaPesquisaProduto_DialogCestaProdutos_BotaoRemoverTodos */}
              <th id="TabelaProdutosSelecionados_Tabela_CabecalhoAcoes"
                style={{ whiteSpace: "nowrap" }}
                className={estilosBarraFerramentasGrid.cabecalhoFixo}
              >Quantidade
              </th>
              {exibirColunaCodigo &&
                <th id="TabelaProdutosSelecionados_Tabela_CabecalhoCodigo"
                  className={estilosBarraFerramentasGrid.cabecalhoFixo}
                >Código</th>}
              {exibirColunaReferencia &&
                <th id="TabelaProdutosSelecionados_Tabela_CabecalhoReferencia"
                  className={estilosBarraFerramentasGrid.cabecalhoFixo}
                >Referência</th>}
              <th id="TabelaProdutosSelecionados_Tabela_CabecalhoDescricao"
                className={estilosBarraFerramentasGrid.cabecalhoFixo}
              >Descrição</th>
              <th id="TabelaProdutosSelecionados_Tabela_CabecalhoUnidade"
                className={estilosBarraFerramentasGrid.cabecalhoFixo}
              >Unid.</th>
              <th id="TabelaProdutosSelecionados_Tabela_CabecalhoPrecoUnitario"
                className={clsx(estilosBarraFerramentasGrid.cabecalhoNumericoCestaProdutos, estilosBarraFerramentasGrid.cabecalhoFixo)}
              >Preço Unitário</th>
              <th id="TabelaProdutosSelecionados_Tabela_CabecalhoAcoesDireita"
                className={estilosBarraFerramentasGrid.cabecalhoFixo}
              >
              </th>
            </tr>
          </thead>
          <tbody id="TabelaProdutosSelecionados_Tabela_Corpo">
            {produtosSelecionados.map((produto) => {
              // 491123 — key/estado de UI desta linha usam o identificador da cesta (pode ser uma
              // duplicata de "Inserir Novo"), nunca produto.Codigo puro (compartilhado entre duplicatas)
              const identificadorLinha = obterIdentificadorLinha(produto)
              return (
                <tr key={identificadorLinha} id={`TabelaProdutosSelecionados_ProdutoSelecionado_${produto.Codigo}`}
                  className={clsx(`item-orcamento-${produto.Codigo}`, produtoRemovendo == identificadorLinha && estilosBarraFerramentasGrid.linhaRemovendo)}
                >
                  {/* 491123 — recriado a partir do Figma (node-id 270-603): coluna da esquerda só
                    com a faixa colorida (boxShadow) + stepper de quantidade. Os ícones de ação
                    (informações, tinta, imagens, repetido, remover) ficam na coluna "Ações", à
                    direita de "Preço Unitário" (ver TabelaProdutosSelecionados_ProdutoSelecionado_ColunaAcoes). */}
                  <td id={`TabelaProdutosSelecionados_ProdutoSelecionado_ColunaRemover_${produto.Codigo}`}
                    style={{ boxShadow: `${produto.Cor != "#000000" ? `4px 0px ${produto.Cor} inset` : ""}` }}
                  >
                    <div className={estiloItemPesquisaProduto.stepperQuantidade}
                      id={`TabelaProdutosSelecionados_ProdutoSelecionado_stepperQuantidade_${produto.Codigo}`}
                      title={(produto.Quantidade ?? 0) > 0
                        ? `Total: ${globalMU.formatarValorNumerico(produto.Preco * (produto.Quantidade ?? 0), 2, true)}`
                        : undefined}
                    >
                      <button
                        type="button"
                        className={clsx(estiloItemPesquisaProduto.stepperBotao, "no-global-button")}
                        disabled={(produto.Quantidade ?? 0) <= 0}
                        title="Diminuir quantidade"
                        id={`TabelaProdutosSelecionados_ProdutoSelecionado_BotaoDiminuirQuantidade_${produto.Codigo}`}
                        onClick={() => onAlterarQuantidade(produto, Math.max(0, (produto.Quantidade ?? 0) - obterPassoQuantidade(produto)))}
                      >-</button>
                      <InputNumerico
                        id={`TabelaProdutosSelecionados_ProdutoSelecionado_InputQuantidade_${produto.Codigo}`}
                        numeroCasasDecimais={contexto.numeroCasasDecimaisQuantidade}
                        valor={produto.Quantidade}
                        classesInput={[estiloItemPesquisaProduto.stepperInput]}
                        style={{ width: "60px", border: "none" }}
                        selecionaValorOnFocus={true}
                        //disabled={contexto.orcamentoSomenteLeitura || produto.EtiquetaPesagem}
                        title={produto.EtiquetaPesagem
                          ? "Entrada do produto realizada através da leitura de etiqueta. Quantidade do produto não pode ser alterada."
                          : undefined}
                        onValorModificado={(quantidade) => onAlterarQuantidade(produto, quantidade)}
                      />
                      <button
                        type="button"
                        className={clsx(estiloItemPesquisaProduto.stepperBotao, "no-global-button")}
                        title="Aumentar quantidade"
                        id={`TabelaProdutosSelecionados_ProdutoSelecionado_BotaoAumentarQuantidade_${produto.Codigo}`}
                        onClick={() => onAlterarQuantidade(produto, (produto.Quantidade ?? 0) + obterPassoQuantidade(produto))}
                      >+</button>
                    </div>
                  </td>
                  {exibirColunaCodigo && (
                    <td id={`TabelaProdutosSelecionados_ProdutoSelecionado_Codigo_${produto.Codigo}`}>
                      {produto.Codigo}
                    </td>
                  )}
                  {exibirColunaReferencia && (
                    <td id={`TabelaProdutosSelecionados_ProdutoSelecionado_Referencia_${produto.Codigo}`}>
                      {produto.Referencia}
                    </td>
                  )}
                  <td id={`TabelaProdutosSelecionados_ProdutoSelecionado_Descricao_${produto.Codigo}`}>
                    {contexto.exibirTextoTecnico && produto.TextoTecnico?.length > 0 &&
                      produto.TextoTecnico?.replace(/\s/g, "")?.length > 0 ? (
                      <TooltipMU
                        id={`TabelaProdutosSelecionados_ToolTipTextoTecnico_${produto.Codigo}`}
                        key={`TabelaProdutosSelecionados_ToolTipTextoTecnico_${produto.Codigo}`}
                        title={
                          <div style={{ whiteSpace: 'pre-wrap', textAlign: 'left' }}>
                            <span style={{ color: 'gray', fontWeight: 'bold' }}>Texto técnico:</span> <br></br> {produto.TextoTecnico?.replace(/(\f|\t)/g, (match) => {
                              if (match === '\f') return ' ';
                              if (match === '\t') return '    ';
                            })}
                          </div>
                        }
                      >
                        <span style={{ borderBottom: "1px dotted", color: produto.EmOferta ? "var(--mu-azul-marcador, blue)" : "inherit" }}
                        >{produto.Descricao}</span>
                      </TooltipMU>
                    ) : (
                      produto.Descricao
                    )}
                  </td>
                  <td id={`TabelaProdutosSelecionados_ProdutoSelecionado_Unidade_${produto.Codigo}`}>
                    {produto.Unidade1}
                  </td>
                  <td id={`TabelaProdutosSelecionados_ProdutoSelecionado_PrecoUnitario_${produto.Codigo}`}
                    className={estilosBarraFerramentasGrid.dadoNumericoCestaProdutos}
                  >
                    {globalMU.formatarValorNumerico(produto.Preco, 2, true)}
                  </td>
                  <td id={`TabelaProdutosSelecionados_ProdutoSelecionado_ColunaAcoes_${produto.Codigo}`}>
                    <div className={estilosBarraFerramentasGrid.colunaAcoesCestaProdutos}>
                      <i
                        id={`TabelaProdutosSelecionados_ProdutoSelecionado_BotaoRemover_${produto.Codigo}`}
                        className={clsx(
                          "material-symbols-rounded",
                          estilosBotoes.iconeMaterialAcao,
                          (processandoProduto || produtoRemovendo == identificadorLinha) && estilosBotoes.desabilitado
                        )}
                        style={{ fontSize: "22px" }}
                        tabIndex={0}
                        title="Remover produto"
                        onClick={() => { if (!processandoProduto && produtoRemovendo != identificadorLinha) onRemoverComAnimacao(produto) }}
                      >delete
                      </i>
                      {(produto.TipoComponente == "P" || produto.BaseTintometricoSimplificado) && ( // PA 402355 repasse 311033 BaseTintometricoSimplificado
                        <button title="Seleciona cor da tinta"
                          id={`ItemPesquisaProduto_BotaoTinta_${produto.CodigoProduto}`}
                          key={`ItemPesquisaProduto_BotaoTinta_${produto.CodigoProduto}`}
                          onClick={() => contexto.onMostrarTinta(produto)}
                          className={clsx(
                            estilosBotoes.botaoIcone,
                            produto.Codigo in contexto.tintasConfiguradas
                              ? estiloItemPesquisaProduto.botaoTintaVerde
                              : estiloItemPesquisaProduto.botaoTintaCinza,
                            "no-global-button"
                          )}
                        ></button>
                      )}
                      {produtoJaExisteNoOrcamento(produto) && (
                        <button
                          onClick={() => onProdutoRepetido(produto)}
                          id={`ItemPesquisaProduto_BotaoRepetido_${produto.Codigo?.trim()}`}
                          className={clsx(
                            estilosBotoes.botaoIcone,
                            produtosRepetidos[identificadorLinha] == undefined && produto.AcaoProdutoRepetido == null
                              ? estiloItemPesquisaProduto.botaoRepetido
                              : "",
                            "no-global-button"
                          )}
                          title="Produto Repetido"
                        >
                          {produtosRepetidos[identificadorLinha] == "desmembrar" || produto.AcaoProdutoRepetido == 0 ? (
                            <FontAwesomeIcon
                              icon={faPlusCircle}
                              title="Adiciona Novo Item Duplicado"
                              id={`ItemPesquisaProduto_IconeDesmembrar_${produto.Codigo}`}
                            />
                          ) : produtosRepetidos[identificadorLinha] == "incrementar" || produto.AcaoProdutoRepetido == 1 ? (
                            <FontAwesomeIcon
                              icon={faArrowAltCircleUp}
                              title="Incrementa Quantidade no Item Duplicado"
                              id={`ItemPesquisaProduto_Iconeincrementar_${produto.Codigo}`}
                            />
                          ) : (
                            ""
                          )}
                        </button>
                      )}

                      {/* devem ser os ultimos botoes    */}
                      <button
                        className={clsx(estilosBotoes.botaoIcone, "no-global-button")}
                        title="Mostra informações detalhadas do produto"
                        id={`TabelaProdutosSelecionados_ProdutoSelecionado_BotaoInformacoes_${produto.Codigo}`}
                      >
                        <FontAwesomeIcon
                          icon={faInfoCircle}
                          onClick={() => onMostrarInformacoesProduto(produto)}
                        />
                      </button>
                      {(produto.Imagens ?? []).length > 0 && (
                        <button title="Visualiza as imagens/vídeos do produto"
                          id={`ItemPesquisaProduto_BotaoImagens_${produto.CodigoProduto}`}
                          key={`ItemPesquisaProduto_BotaoImagens_${produto.CodigoProduto}`}
                          className={clsx(estilosBotoes.botaoIcone, "no-global-button")}
                          onClick={() => {
                            // 491123 — fecha o modal da cesta antes de abrir o lightGallery: o
                            // Dialog do MUI fica por cima da galeria e atrapalha a visualização da
                            // imagem. O dispatch de fechar é assíncrono (batched pelo React), então
                            // o elemento ainda existe no DOM neste instante para o lightGallery
                            // conseguir se anexar antes do modal desmontar.
                            contexto.onFecharModalCestaProdutos()
                            contexto.onMostrarImagens(produto.Codigo, `item-orcamento-${produto.Codigo}`)
                          }}
                        >
                          <FontAwesomeIcon icon={faCamera} />
                        </button>
                      )}
                      {/* devem ser os ultimos botoes    */}
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};
